export const NAME = 'user';

